import { buildProps } from '@xzx-design/utils'

import type { ExtractPropTypes } from 'vue-demi' // test vue-demi
import type Text from './text.vue'

export const textProps = buildProps({
  type: {
    type: String,
    default: '',
  },
  display: {
    type: String,
    default: '',
  },
  weight: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: '',
  },
  textAlign: {
    type: String,
    default: 'left',
  },
  ellipsis: {
    type: Number,
    default: 0,
  },
})

export type TextProps = ExtractPropTypes<typeof textProps>
export type TextInstance = InstanceType<typeof Text>
